import React from "react";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useTheme } from "../../contexts/ThemeContext.tsx";
import { parseJwt } from "../../utils/token.util.ts";
import NotificationCenter from "../NotificationCenter/index.tsx";

interface HeaderProps {
  toggleMenu: () => void;
}

const Header: React.FC<HeaderProps> = ({ toggleMenu }) => {
  const navigate = useNavigate();
  const { darkMode, toggleDarkMode } = useTheme();
  const emailUsuario = parseJwt(localStorage.getItem("token"))?.sub as string | undefined;

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <header className="ds-topbar">
      <button type="button" className="ds-menu-toggle" onClick={toggleMenu} aria-label="Abrir menu">
        <MenuIcon fontSize="small" />
      </button>

      <div className="ds-topbar-spacer" />

      <div className="ds-topbar-actions">
        <Tooltip title="Alternar tema">
          <button type="button" className="ds-icon-btn" onClick={toggleDarkMode} aria-label="Alternar tema">
            {darkMode ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
          </button>
        </Tooltip>
        <NotificationCenter />
        <Tooltip title="Ajuda">
          <a
            className="ds-icon-btn"
            href="https://wa.me/5518981342600?text=Quero%20ajuda%20com%20o%20Agenda%20de%20Cirurgia!"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Ajuda"
          >
            <HelpOutlineIcon fontSize="small" />
          </a>
        </Tooltip>
        <Tooltip title="Sair">
          <button type="button" className="ds-icon-btn" onClick={handleLogout} aria-label="Sair">
            <LogoutOutlinedIcon fontSize="small" />
          </button>
        </Tooltip>
      </div>

      <div
        className="ds-topbar-avatar"
        role="button"
        tabIndex={0}
        onClick={() => navigate("/configuracoes")}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            navigate("/configuracoes");
          }
        }}
      >
        <div className="ds-avatar">{(emailUsuario ?? "?").slice(0, 2).toUpperCase()}</div>
        <div className="name">
          <strong>{emailUsuario ?? "Usuário"}</strong>
          <span>Minha conta</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
